import AutorunQuery from './AutorunQuery';

export default AutorunQuery;
